<template>
  <form name="publications-form" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
    <v-row dense>
      <v-col md="8" lg="6">
        <BAutocompleteProcedure v-model="form.procedure" validate="required" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col md="12" lg="12">
        <v-checkbox
          v-model="form.is_remote"
          label="Электронный"
          dense
          class="mb-1 py-0"
        />
        <v-checkbox
          v-model="form.is_gramotnost"
          label="Грамотность"
          dense
          class="mb-1 py-0"
        />
      </v-col>
    </v-row>
    <v-row dense>
    <v-col md="2" lg="4">
        <v-textarea v-model="form.meta" outlined rows="1" dense label="Дополнительная информация" />
      </v-col>
    </v-row>

      <slot name="save-menu" />
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BAutocompleteProcedure from '@/components/forms/BAutocompleteCommon/BAutocompleteProcedureMarks.vue'

const createDefaultData = () => ({
})

export default {
  name: 'MarksForm',
  components: {
    BLayoutExpansion,
    BAutocompleteProcedure,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    loading: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  watch: {
    'form.is_remote'(val) {
      if (val && this.form.is_gramotnost) {
        this.form.is_gramotnost = false;
      }
    },
    'form.is_gramotnost'(val) {
      if (val && this.form.is_remote) {
        this.form.is_remote = false;
      }
    }
  }
}
</script>
